const omitLeadingZero = (num: string) => (num[0] === '0' ? num.slice(1) : num)

const toMonthDayYearString = (input: string) => {
  try {
    const date = new Date(input)
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
    const formatted = date.toLocaleDateString(
      'en-US',
      options as Intl.DateTimeFormatOptions
    )
    if (/invalid/gi.test(formatted)) {
      throw new Error('Invalid date parse first attempt')
    }
    return formatted
  } catch (error) {
    const [omitTime] = input.split('T')
    const [year, month, day] = omitTime.split('-')
    if (year && month && day) {
      return `${omitLeadingZero(month)}/${omitLeadingZero(day)}/${year}`
    }
  }
  return '-'
}

export default toMonthDayYearString



// WEBPACK FOOTER //
// ./src/utils/Date.ts